var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "fab-container"
  }, [_c('transition', {
    attrs: {
      "name": "fab-menu"
    }
  }, [_vm.menuOpen ? _c('div', {
    staticClass: "fab-menu"
  }, _vm._l(_vm.selectedShortcuts, function (shortcut) {
    return _c('b-button', {
      key: shortcut.id,
      staticClass: "fab-item px-8 py-3 my-2",
      attrs: {
        "variant": "info",
        "pill": ""
      },
      on: {
        "click": function click($event) {
          return _vm.navigateToShortcut(shortcut.id);
        }
      }
    }, [_vm._v(" " + _vm._s(shortcut.shortcutLabel) + " ")]);
  }), 1) : _vm._e()]), _c('b-button', {
    staticClass: "px-8 py-4",
    attrs: {
      "variant": "primary",
      "size": "lg",
      "pill": ""
    },
    on: {
      "click": _vm.toggleMenu
    }
  }, [_vm._v(" Atalhos ")])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };